// @flow
import iniOSectionEvents from './../../event/js/OSectionEvents';

// ini on load
window.addEventListener('DOMContentLoaded', () => {
	iniOSectionEvents(document);

	console.log('%cSite event is ready', 'background: #8be09f; color: #39485e');
});
